import React from 'react'

import { FavoriteButton } from '../../../FavoriteButton'
import { LinkProps } from '../../../Link'
import { renderWithOptionalLink } from '../../utils'
import { Container, Title, TitleVariant, TitleWrapper } from './styles'

export interface CardContentHeadingProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Title variant
   */
  variant?: TitleVariant

  /**
   * Heading icon
   */
  icon?: React.ReactNode

  /**
   * Link
   */
  href?: LinkProps['href']

  /**
   * Link `as` prop
   */
  as?: LinkProps['as']

  /**
   * Is external link
   */
  external?: LinkProps['external']

  /**
   * Link target
   */
  target?: LinkProps['target']

  /**
   * Title as element
   */
  titleAs?: keyof HTMLElementTagNameMap

  /**
   * Is favorited
   */
  isFavorited?: boolean

  /**
   * Is favorite loading
   */
  isFavoriteLoading?: boolean

  /**
   * Favorite click handler (Favorite button will be hidden if not provided)
   */
  onFavoriteClick?: () => void

  /**
   * Content
   */
  children?: React.ReactNode
}

export const CardContentHeading = ({
  className,
  icon,
  variant = 'primary',
  href,
  as,
  external,
  target,
  titleAs,
  isFavorited = false,
  isFavoriteLoading = false,
  onFavoriteClick,
  children,
}: CardContentHeadingProps) => {
  return (
    <Container className={className}>
      {icon}

      <TitleWrapper hasLeftContent={!!icon} hasRightContent={!!onFavoriteClick}>
        {renderWithOptionalLink(
          <Title variant={variant} as={titleAs}>
            {children}
          </Title>,
          { href, as, external, target },
        )}
      </TitleWrapper>

      {onFavoriteClick && (
        <FavoriteButton
          favorited={isFavorited}
          onClick={onFavoriteClick}
          isLoading={isFavoriteLoading}
        />
      )}
    </Container>
  )
}
